import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./footer.css";
import RedirectToMap from "../../../../constants/MapConstants";
import useRedirectToHome, {
  RedirectToHome,
} from "../../../../utility/redirectfunctions";
import ROUTES from "../../../../constants/RouteData";

const footerLinks1 = ["Personal Loan", "Business Loan", "PayOff"];
const footerLinks2 = ["RBI Sachet", "FAQs", "EMI Calculator"];
const footerLinks3 = ["Digital Lending Partners", "Contact us", "Unsubscribe"];

const FooterSection = () => {
  const RedirectToHome = useRedirectToHome();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const socialIcons = [
    {
      Icon: "/assets/img/fb.png",
      href: "https://www.facebook.com/DigitMoneyTechnologies",
    },
    {
      Icon: "/assets/img/instagram.png",
      href: "https://www.instagram.com/digitmoney.india/#",
    },
    {
      Icon: "/assets/img/LinkedInImg.png",
      href: "https://www.linkedin.com/company/digitmoney/",
    },
    { Icon: "/assets/img/youtube.png", href: "#" },
    { Icon: "/assets/img/twitterX.png", href: "https://x.com/DigitMoneyIndia" },
    {
      Icon: "/assets/img/whatsappB.png",
      href: "https://api.whatsapp.com/send/?phone=9076324177&type=phone_number&app_absent=0",
    },
  ];

  const getLinkPath = (label) => {
    switch (label.toLowerCase()) {
      case "contact us":
        return ROUTES.contactUs;
      case "unsubscribe":
        return ROUTES.dndService;
      case "terms of use":
      case "terms & conditions":
      case "privacy policy":
        return ROUTES.termsOfUsage;
      case "faqs":
        return `${ROUTES.home}#faq`;
      case "emi calculator":
        return `${ROUTES.home}#emiCalculator`;
      case "personal loan":
        return ROUTES.personalLoan;
      case "business loan":
        return ROUTES.businessLoan;
      case "digital lending partners":
        return ROUTES.partners;
      case "rbi sachet":
        return "https://sachet.rbi.org.in/";
      case "payoff":
        return "https://payoff.club/";
      default:
        return null;
    }
  };

  const MobileFooter = () => (
    <footer className="bg-black w-full min-h-fit text-white px-4 py-10 z-0">
      <div className="max-w-7xl mx-auto flex flex-col justify-center items-center gap-6">
        {/* Logo */}
        <div className="w-full max-w-5xl">
          <img
            onClick={RedirectToHome}
            src="/assets/img/newLogo.png"
            alt="Company Logo"
            height="24"
            width="142"
            className="cursor-pointer"
          />
        </div>

        {/* Taglines */}
        <h1
          style={{ fontFamily: "myFirstFont" }}
          className=" [@media(max-width:340px)]:text-[25px] text-[35px] text-left w-full"
        >
          Quick & Hassle-Free Personal Loan
        </h1>

        <button
          style={{ fontFamily: "myFirstFont" }}
          className="w-full rounded-lg  px-2 py-3  border-2 border-[#12F280] xs:text-[12px] text-[16px] text-[#12F280]"
        >
          Get up to ₹5,00,000 Instantly
        </button>

        {/* Info + Links */}
        <div className="flex w-full max-w-5xl flex-col justify-between gap-3">
          {/* Footer Links - Mobile */}
          <div
            style={{ fontFamily: "Atkinson-regular" }}
            className="grid grid-cols-2 mt-4 gap-6 text-[14px] text-gray-300"
          >
            <div className="flex flex-col space-y-3">
              {[...footerLinks1, ...footerLinks2].map((label, i) => {
                const path = getLinkPath(label);
                return path ? (
                  <Link
                    key={i}
                    onClick={() => {
                      window.location.href = `${path}`;
                    }}
                    className="hover:text-white transition-colors"
                  >
                    {label}
                  </Link>
                ) : (
                  <span key={i} className="text-gray-400">
                    {label}
                  </span>
                );
              })}
            </div>
            <div className="flex flex-col space-y-3">
              {footerLinks3.map((label, i) => {
                const path = getLinkPath(label);
                return path ? (
                  <Link
                    key={i}
                    onClick={() => {
                      window.location.href = `${path}`;
                    }}
                    className="hover:text-white text-[14px] transition-colors"
                  >
                    {label}
                  </Link>
                ) : (
                  <span key={i} className="text-gray-400">
                    {label}
                  </span>
                );
              })}
            </div>
          </div>
        </div>

        <div className="w-full text-[#717171]">
          <div style={{ fontFamily: "Atkinson-regular" }}>
            <b className="text-green-600 text-[18px]">
              DigitMoney Technologies Pvt. Ltd.
            </b>{" "}
            <br />
            <br />
            <p
              className=" text-[18px] xs:text-[15px] hover:text-green-400 cursor-pointer"
              onClick={RedirectToMap}
            >
              1341 Regus Platinum <br className="block" />
              Business Centre Pvt Ltd,
              <br />
              Level 13, Platinum Techno Park,
              <br />
              Plot No. 17 & 18, Sector 30A, Vashi,
              <br />
              Navi Mumbai - 400705
            </p>
          </div>

          <div
            style={{ fontFamily: "Atkinson-regular" }}
            className="block mt-4"
          >
            <p className="text-[14px]">Grievance Redressal Officers</p>
            <p className="text-[14px]">
              Ammy Pinheiro:{" "}
              <a href="mailto:grievance@digitmoney.in" target="_blank">
                grievance@digitmoney.in
              </a>
            </p>
          </div>
        </div>

        <div className="flex w-full items-center gap-4 flex-wrap mt-6 mb-5">
          {socialIcons.map(({ Icon, href }, i) => (
            <a
              key={i}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              className="group h-[25px] w-[25px] rounded-full flex items-center justify-center transition-all"
            >
              <div
                className="h-full w-full bg-gray-400 group-hover:bg-green-500 transition-colors duration-300"
                style={{
                  WebkitMask: `url(${Icon}) center / contain no-repeat`,
                  mask: `url(${Icon}) center / contain no-repeat`,
                }}
              ></div>
            </a>
          ))}
        </div>

        {/* Bottom Bar - Mobile */}
        <div
          className="text-[#4B4B4B] text-[14px] space-y-4 w-full"
          style={{ fontFamily: "Atkinson-regular" }}
        >
          <hr className="border-gray-700" />
          <div className="flex flex-col gap-2 py-6">
            <Link
              to={ROUTES.termsOfUsage}
              reloadDocument={true}
              className="hover:text-white transition"
            >
              Terms of Use
            </Link>
            <Link
              to={ROUTES.privacyPolicy}
              reloadDocument={true}
              className="hover:text-white transition"
            >
              Privacy Policy
            </Link>
          </div>
          <hr className="border-gray-700" />
          <p className="text-left py-4 text-[12px]">
            &copy; 2025,{" "}
            <a
              href="https://web.digitmoney.in/"
              className="hover:text-green-500"
            >
              DigitMoney Technologies Pvt. Ltd.
            </a>{" "}
            All Rights Reserved.
          </p>
        </div>
      </div>
    </footer>
  );

  const DesktopFooter = () => (
    <footer className="bg-black w-full min-h-content text-white px-4 md:py-8 bg-black/30 z-0">
      <div className="max-w-7xl mx-auto flex flex-col justify-center items-center gap-6 border-t border-gray-600 pt-[80px]">
        {/* Logo */}
        <div className="w-full max-w-5xl">
          <img
            onClick={RedirectToHome}
            src="/assets/img/newLogo.png"
            alt="Company Logo"
            height="24"
            width="142"
            className="cursor-pointer"
          />
        </div>

        {/* Taglines */}
        <h4
          style={{ fontFamily: "myFirstFont" }}
          className="w-full text-5xl mb-4"
        >
          {" "}
          Quick & Hassle-Free Personal Loan
        </h4>

        {/* Info + Links */}
        <div className="flex w-full max-w-5xl flex-col md:flex-row justify-between gap-3">
          <div className="flex flex-col gap-6 text-sm text-gray-400 md:w-1/2">
            <div style={{ fontFamily: "Atkinson-regular" }}>
              <b className="text-green-600 text-[18px]">
                DigitMoney Technologies Pvt. Ltd.
              </b>{" "}
              <br />
              <br />
              <p
                className="text-[18px] hover:text-green-400 cursor-pointer"
                onClick={RedirectToMap}
              >
                1341 Regus Platinum Business Centre Pvt Ltd,
                <br />
                Level 13, Platinum Techno Park,
                <br />
                Plot No. 17 & 18, Sector 30A, Vashi,
                <br />
                Navi Mumbai - 400705
              </p>
            </div>
            <div style={{ fontFamily: "Atkinson-regular" }} className="mt-2">
              <p className="text-[14px]">Grievance Redressal Officers</p>
              <p className="text-[14px]">
                Ammy Pinheiro:{" "}
                <a href="mailto:grievance@digitmoney.in">
                  grievance@digitmoney.in
                </a>
              </p>
            </div>
            <div className="flex items-center gap-4 flex-wrap mt-6 mb-5">
              {socialIcons.map(({ Icon, href }, i) => (
                <a
                  key={i}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group h-[25px] w-[25px] rounded-full flex items-center justify-center transition-all"
                >
                  <div
                    className="h-full w-full bg-gray-400 group-hover:bg-green-500 transition-colors duration-300"
                    style={{
                      WebkitMask: `url(${Icon}) center / contain no-repeat`,
                      mask: `url(${Icon}) center / contain no-repeat`,
                    }}
                  ></div>
                </a>
              ))}
            </div>
          </div>

          {/* Footer Links - Desktop */}
          <div
            style={{ fontFamily: "Atkinson-regular" }}
            className="grid grid-cols-3 gap-6 text-[14px] text-gray-300"
          >
            {[footerLinks1, footerLinks2, footerLinks3].map((group, index) => (
              <div key={index} className="flex flex-col space-y-3">
                {group.map((label, i) => {
                  const path = getLinkPath(label);
                  return path ? (
                    <Link
                      key={i}
                      reloadDocument={true}
                      target={
                        label === "RBI Sachet" || label === "PayOff"
                          ? "_blank"
                          : "_self"
                      }
                      to={path}
                      className="hover:text-white text-md transition-colors"
                    >
                      {label}
                    </Link>
                  ) : (
                    <span key={i} className="text-gray-400">
                      {label}
                    </span>
                  );
                })}
              </div>
            ))}
          </div>
        </div>

        {/* Bottom Bar - Desktop */}
        <div
          style={{ fontFamily: "Atkinson-regular" }}
          className="border-t-[2px] border-[#4B5466] pt-10 text-center text-[12px] text-[#525252] md:flex md:w-full md:justify-between md:items-center"
        >
          <div className="flex flex-col md:flex-row justify-center items-center gap-[10px] md:gap-[30px]">
            <Link
              to={ROUTES.termsOfUsage}
              reloadDocument={true}
              className="hover:text-gray-300 cursor-pointer"
            >
              Terms of Use
            </Link>
            <Link
              to={ROUTES.privacyPolicy}
              reloadDocument={true}
              className="hover:text-gray-300 cursor-pointer"
            >
              Privacy Policy
            </Link>
          </div>
          <p className="">
            {" "}
            &copy; 2025,{" "}
            <a
              href="https://web.digitmoney.in/"
              className="hover:text-green-500"
            >
              DigitMoney Technologies Pvt. Ltd.
            </a>{" "}
            All Rights Reserved.
          </p>
        </div>
      </div>
    </footer>
  );

  return isMobile ? <MobileFooter /> : <DesktopFooter />;
};

export default FooterSection;
